import React from "react";
import { LOGIN_ROUTE } from "Constants";
import { useLoginInfo, useRedirect } from "Hooks";
import PasswordResetLayout from "../../components/PasswordResetLayout";
import RequestResetForm from "../../components/RequestResetForm/RequestResetForm";

const RequestReset = (): React.JSX.Element => {
  const { hasLoaded, isSSOLogin } = useLoginInfo();

  useRedirect({
    to: `/${LOGIN_ROUTE}`,
    when: hasLoaded && isSSOLogin,
  });

  return (
    <PasswordResetLayout>
      <RequestResetForm />
    </PasswordResetLayout>
  );
};

export default RequestReset;
